<template>
  <div class="login-box">
    <div class="login-head">
      <img src="@/assets/head-logo.png"/>诚云·工资条
      <!--公司自己用需放开注释掉的-->
      <!--<a style="float:right;font-size:16px;color:#2BA5F6;text-decoration:none;" href="http://gzt.renligongshe.com/home.html">员工工资查询</a>-->
    </div>
    <div class="login-main">
      <div  class="login-con clearfix">
        <img src="@/assets/login-head.png" class="fl"/>
        <el-form :model="loginForm" ref="loginForm" :rules="rules" label-position="left" label-width="0px"
                 class="login-container fr">
          <!--公司自己用需放开注释掉的，隐藏掉账号登录-->
          <!--<h2 class="title">HR登录</h2>-->
          <h2 class="title">账号登录</h2>
          <el-form-item prop="account">
            <el-input type="text" v-model="loginForm.account" auto-complete="off" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="请输入登录密码"></el-input>
          </el-form-item>
          <el-form-item style="width:100%;margin-bottom:10px;">
            <el-button type="primary" @click="login" :loading="loading">立 即 登 录</el-button>
          </el-form-item>
          <router-link to='Register'><button class="login-goResister">还没有账号，现在注册</button></router-link>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  import Cookies from "js-cookie"
  export default {
    name: 'Login',
    data() {
      //手机号校验
      let checkPhone = (rule,value,callback)=>{
          const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
          if (value === '') {
              callback(new Error('请输入登录账号'))
          } else if (!reg.test(value)) {
              callback(new Error('登录账号只允许手机号码'))
          } else {
              callback()
          }
      };
      return {
        loading: false,
        loginForm: {
          account: '',
          password: '',
        },
        rules: {
          account: [
            {validator: checkPhone, trigger: 'change' }
          ],
          password: [
            {required: true, message: '请输入登录密码',trigger: 'blur'}
          ],
        },
      }
    },
    methods: {
      login() {
        this.$refs.loginForm.validate((valid) => {
            if (valid) {
              this.loading = true;
              let userInfo = {
                  account:this.loginForm.account,
                  password:this.loginForm.password
              };
              Cookies.set('token', ''); //每次登录之前需要先清空一下token
              this.$api.login.login(userInfo).then((res) => {
                if(res.msg != null) {
                  this.$message({
                    message: res.msg,
                    type: 'error'
                  });
                } else {
                  Cookies.set('token', res.data.token) // 放置token到Cookie
                  sessionStorage.setItem('thirdParty',true); // 从第三方登录进来
                  sessionStorage.setItem('user', userInfo.account) // 保存用户到本地会话
                  this.$router.replace('/')  // 登录成功，跳转到主页
                }
                this.loading = false
              }).catch((res) => {
                this.$message({
                  message: res.message,
                  type: 'error'
                });
              });
            }
        });
      },
    },
    created() {
      let that = this;
      document.onkeypress = function(e) {
        var keycode = document.all ? event.keyCode : e.which;
        if (keycode == 13) {
          that.login();// 登录方法名
          return false;
        }
      };
    },
    mounted() {

    },
    computed:{

    }
  }
</script>

<style lang="scss" scoped>
  .fl{
    float:left;
  }
  .fr{
    float:right;
  }
  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .clearfix {zoom:1 }
  .login-box{
    height:100%;
    overflow:hidden;
  }
  .login-con,.login-head{
    width:1000px;
    margin:0 auto;
  }
  .login-head{
    font-size:24px;
    color:#2B2B2B;
    line-height:70px;
    text-align: left;
    font-weight:bold;
    img{
      width:51px;
      vertical-align:middle;
      margin:-8px 10px 0 0;
    }
  }
  .login-main{
      height:680px;
      background: url("../assets/login-bg.png") no-repeat;
      background-size:100% 100%;
  }
  .login-con{
    padding-top:120px;
  }
  .login-con img.fl{
    width:400px;
    margin-top:30px;
  }
  .login-container {
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    width:352px;
    padding:42px 38px;
    background: #fff;
    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color:#454545;
      font-size:20px;
    }
    .el-form-item{
      margin-bottom:20px;
    }
    .el-button--primary{
      background-color:#2BA5F6;
      border-color:#2BA5F6;
      width:99%;
    }
    .login-goResister{
      color:#2BA5F6;
      border: none;
      background: none;
      cursor: pointer;
      font-size:12px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/Login.vue